export default __webpack_public_path__ + "static/media/Login-Greetings.3d5ddbe7.jpeg";